import { EMPTY_LIST, NOTIFICATION_TYPE } from '../../../../constants/common'
import { isApiConflictStatus } from '../../../../utils/api'
import {
  APPLICANT_STAGE,
  APPLICANT_STAGES,
  getIsMockApplicantId,
  getRentalPortalApplicantIdentityLabel,
} from '../../../RentalPortalApplicant'

import {
  APPLICANT_CONFIRMED_TRANSITION,
  APPLICANT_MOCK_STAGE_TRANSITION_AVAILABLE,
  APPLICANT_MOVE_TO_SCREENING_TRANSITION,
  APPLICANT_STAGE_TRANSITION,
  APPLICANT_STAGE_TRANSITION_AVAILABLE,
  APPLICANT_TRANSITION_NO_RIGHT_REASON,
} from './RentalPortalApplicantProfileHeaderStageSelect.constants'

function getApplicantAvailableStageTransitions(applicantData) {
  return getIsMockApplicantId(applicantData?.id)
    ? APPLICANT_MOCK_STAGE_TRANSITION_AVAILABLE
    : APPLICANT_STAGE_TRANSITION_AVAILABLE
}

function getIsApplicantUnderApprovalReject({ applicantData, transition }) {
  return (
    applicantData?.stage === APPLICANT_STAGE.selected &&
    transition?.key === APPLICANT_STAGE.rejected &&
    transition.reason !== APPLICANT_TRANSITION_NO_RIGHT_REASON
  )
}

export function getApplicantStageSelectValue({ stage, t }) {
  return APPLICANT_STAGES[stage]
    ? {
        label: t(APPLICANT_STAGES[stage].text),
        textColor: APPLICANT_STAGES[stage].textColor,
        value: stage,
      }
    : null
}

export function getApplicantStageTransitions(applicantData) {
  return (applicantData?.available_transitions ?? EMPTY_LIST).filter(
    transition => APPLICANT_STAGE_TRANSITION[transition.key]
  )
}

export function getApplicantTransitionTooltipKey({
  applicantData,
  transition,
}) {
  if (!transition?.permitted) {
    return getIsApplicantUnderApprovalReject({ applicantData, transition })
      ? 'RentalPortal.ApplicantProfileStageRejectUnderApprovalTooltipKey'
      : 'RentalPortal.ApplicantProfileStageTransitionNotAllowedTooltipKey'
  }

  return getApplicantAvailableStageTransitions(applicantData).includes(
    transition.key
  )
    ? null
    : 'RentalPortal.ApplicantProfileStageTransitionUnavailableTooltipKey'
}

export function getApplicantStageSelectOptions({ applicantData, t }) {
  return getApplicantStageTransitions(applicantData).map(transition => {
    const tooltipKey = getApplicantTransitionTooltipKey({
      applicantData,
      transition,
    })

    return {
      disabled: Boolean(tooltipKey),
      label: t(APPLICANT_STAGE_TRANSITION[transition.key].textKey),
      tooltipContent: tooltipKey ? t(tooltipKey) : null,
      value: transition.key,
    }
  })
}

export function getHasEnabledApplicantStageOption(options) {
  return options.some(option => !option.disabled)
}

export function getApplicantMoveToScreeningDescription({ applicantData, t }) {
  return t('RentalPortal.ApplicantProfileMoveToScreeningConfirmationTextKey', {
    name: getRentalPortalApplicantIdentityLabel({
      applicant: applicantData,
      t,
    }),
  })
}

export function getApplicantMoveToScreeningNotifications({ error, t }) {
  return [
    {
      text: t(
        isApiConflictStatus(error?.response?.status)
          ? 'RentalPortal.ApplicantProfileMoveToScreeningConflictErrorKey'
          : 'RentalPortal.ApplicantProfileMoveToScreeningErrorKey'
      ),
      type: NOTIFICATION_TYPE.error,
    },
  ]
}

export function getIsApplicantMoveToScreeningOption(option) {
  const isMoveToScreening =
    option.value === APPLICANT_MOVE_TO_SCREENING_TRANSITION

  return !option.disabled && isMoveToScreening
}

export function getApplicantConfirmedTransition(option) {
  return option.disabled ? null : APPLICANT_CONFIRMED_TRANSITION[option.value]
}

export function getApplicantTransitionNotifications({ error, t }) {
  return [
    {
      text: t(
        isApiConflictStatus(error?.response?.status)
          ? 'RentalPortal.ApplicantProfileStageTransitionConflictErrorKey'
          : 'RentalPortal.ApplicantProfileStageTransitionErrorKey'
      ),
      type: NOTIFICATION_TYPE.error,
    },
  ]
}
